import { Text } from '@nike/eds'

export function TableTitle({ title }) {
  return (
    <Text as="h2" font="title-3" className="table-title">
      {title}
    </Text>
  )
}
